// extracted by mini-css-extract-plugin
export default {"logout":"myButton_logout__3Dp3-"};